module.exports = __webpack_public_path__ + "img/info-icon.6280543f.svg";